import type { GeneralIconName } from '@shared/ui/icon';

/** 검색창 너비 280(Figma · 코드). 토큰에 없는 값이라 인라인 style. 검색 패널은 검색창 왼쪽에 맞춰 헤더 바로 아래 */
export const GLOBAL_HEADER_SEARCH_WIDTH_PX = 280;
/** 검색 결과 패널이 화면 오른쪽을 넘을 때 남길 오른쪽 여백(태블릿, `spacing.gutter` 와 같은 20) */
export const GLOBAL_HEADER_SEARCH_PANEL_EDGE_PX = 20;
/** 계정 메뉴에서 벗어난 뒤 닫기까지 기다리는 시간(코드 값) */
export const GLOBAL_HEADER_MENU_CLOSE_DELAY_MS = 200;

export type GlobalHeaderNavTarget =
  'home' | 'portfolio-evaluation' | 'file' | 'portfolio-report' | 'member';

/** role=staff 의 메뉴 아이콘 순서 */
export const STAFF_NAV_TARGETS = [
  'portfolio-evaluation',
  'file',
  'portfolio-report',
  'member',
] as const satisfies readonly GlobalHeaderNavTarget[];

/** 메뉴 아이콘(Figma GlobalHeader role=staff 의 IconButton 순서: bell · chart-bar · file · toggle-left · user · settings) */
export const STAFF_NAV_ICON_NAME: Record<(typeof STAFF_NAV_TARGETS)[number], GeneralIconName> = {
  'portfolio-evaluation': 'chart-bar',
  file: 'file',
  'portfolio-report': 'toggle-left',
  member: 'user',
};
